import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./ImageTextBlock.module.scss"

const ImageTextBlockSector = ({ data, role }) => {
  let extraClass
  if (role === "disc-list") {
    extraClass = styles.textList
  } else {
    extraClass = styles.text
  }
  if (data.image) {
    let imageLeftOrRight

    imageLeftOrRight =
      data.imageLeftOrRight[0] === "Right" ? "lg:order-1 " : "lg:order-0 "

    return (
      <div className="lg:py-[40px] lg:px-[105px]">
        <div className="lg:flex lg:flex-row lg:max-w-[1224px] lg:mx-auto flex flex-col-reverse font-sans items-center justify-between lg:px-0 px-3">
          <GatsbyImage
            image={data.image?.gatsbyImageData}
            alt={data.image.description ? data.image.description : "image"}
            className={
              imageLeftOrRight +
              " py-auto md:w-[520px] lg:min-w-[520px] lg:h-[390px] rounded-xl overflow-hidden"
            }
            imgStyle={{ objectFit: "contain" }}
            loading={"eager"}
          />
          <div
            className={
              "lg:w-[500px] max-w-[644px] w-fit md:hyphens-none hyphens-auto break-words " +
              extraClass
            }
          >
            <RenderRichContent content={data.text} role={role} />
          </div>
        </div>
      </div>
    )
  } else if (data.image === null) {
    return (
      <>
        <div className="lg:flex lg:flex-row lg:max-w-[1170px] lg:mx-auto font-sans items-center justify-between my-7">
          <div
            className={
              "lg:flex lg:flex-col mx-auto justify-between " +
              styles.textOnlyBlock
            }
          >
            <RenderRichContent
              content={data.text}
              role={"landingpage-video"}
              classNames=" "
            />
          </div>
        </div>
      </>
    )
  }

  // else if (data.embeddedVideo) {
  //   return (
  //     <div
  //       className={
  //         "lg:max-w-[1224px] mx-auto flex w-full flex-col lg:flex-row lg:justify-around justify-center items-center my-7 px-4"
  //       }
  //     >
  //       <div className={"md:text-center " + styles.videoHeader}>
  //         <RenderRichContent content={data.videoHeader} />
  //       </div>
  //       <div className={"w-full rounded-xl"}>
  //         <RenderRichContent content={data.embeddedVideo} />
  //       </div>
  //     </div>
  //   )
  // }
  else {
    return <></>
  }
}
export default ImageTextBlockSector
